import { useQuery } from 'hooks/useCustomQuery';
import getTrunkType from 'API/TrunkTypes/getTrunkType';

const useGetTrunkType = (trunkTypeId, enabled = true) => {
    return useQuery({
        queryKey: ['TrunkType', trunkTypeId],
        queryFn: async () => {
            const response = await getTrunkType(trunkTypeId);
            return response.data;
        },
        enabled: enabled && !!trunkTypeId,
        staleTime: 5 * 60 * 1000,
        retry: false,
        refetchOnWindowFocus: false,
    });
};

export default useGetTrunkType;
